import { Typography } from "@material-ui/core";
import "./BookScreen.css";
import ShowMoreText from "react-show-more-text";

interface TeacherText {
  instructions: string;
}

const TeacherInstructionCard = (props: TeacherText) => {
  return (
    <div className="teacherNotes">
      <Typography className="teacherNotesTitle">Teacher's Instructions </Typography>
      <div className="teacherNotesText">
        <ShowMoreText lines={3} more="More" less="Less">
          {props.instructions}
        </ShowMoreText>
      </div>
    </div>
  );
};
export default TeacherInstructionCard;
